<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-google-classroom" title="Schedule Online Class">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'onlineClass' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete clearable key="id" label="Select Academic Year" :items="academicYears" v-model="selectedAcademicYear" required item-text="academicYear" item-value="id" :hide-details="true"
               @input="()=>{getClassList()}">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete clearable deletable-chips v-model="selectedStaff" multiple :items="staffList" item-text="userName"
              item-value="userID" return-object label="Select Staff" @input="()=>{searchInput=null, getClassList()}" :search-input.sync="searchInput" chips></v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
        <v-card-component class="has-table has-mobile-sort-spaced">
          <form @submit.prevent="scheduleOnlineClass()">
            <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    :label="accessToAllClassFlag ?  '--All Franchisees--' : 'Select Franchisee'"
                    :items="franchisees"
                    v-model="selectedFranchisees"
                    chips
                    deletable-chips
                    multiple
                    item-text="companyName"
                    hide-details
                    @input="filterClasses"
                    return-object
                    clearable
                    :disabled = "accessToAllClassFlag"
                  />
                </v-col>
                <v-col cols="12" md="6">
                <v-radio-group :disabled = "accessToAllClassFlag" v-model="classSection" @change="radioChange" mandatory row>
                  <template v-slot:label>
                    <div><strong>Select</strong></div>
                  </template>
                  <v-radio label="Section wise" :disabled="selectedFranchisees.length>1" value="sectionWise"></v-radio>
                  <v-radio label="Student wise" value="studentWise"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  key="id"
                  :label="classSection === 'studentWise'? 'Franchisee-Class-Section':'Class-Section'"
                  :items="classes"
                  v-model="selectedSections"
                  chips
                  multiple
                  deletable-chips
                  :item-text="classSection === 'studentWise'? 'valueWithFr':'valuez'"
                  return-object
                  clearable
                  @change="()=>{selectedStudents=[], studentList=[]}"
                  hide-details
                  :class="'custom__autocomplete'"
                >
                  <template
                    v-if="classes.length > 0"
                    v-slot:prepend-item
                  >
                    <div class="pl-4 mb-2">
                      <v-checkbox
                        v-model="selectAllClassSectionFlag"
                        class="py-0"
                        @change="selectAllClassSection"
                        hide-details
                      >
                        <template v-slot:label>
                          <span class="ml-3 pl-3">Select All Class-Section</span>
                        </template>
                      </v-checkbox>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" v-if="this.classSection === 'studentWise'">
                <span class="caption font-weight-light"> Action </span>
                <div class="inside">
                  <v-btn normal color="success" dark class="font-weight-bold" @click="getStudents">
                    Get Students
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="6" v-if="this.classSection === 'studentWise'">
                <v-container
                  class="px-0"
                  fluid
                >
                  <v-checkbox
                  @change="()=> {selectedStudents = selectAllStudents ? studentList.map(a=>a.id) : []}"
                  v-model="selectAllStudents"
                    label="Select All Students"
                  ></v-checkbox>
                </v-container>
                <div class="inside">
                  <v-autocomplete
                  :allow-overflow="false"
                    v-if="this.classSection === 'studentWise'"
                    key="id"
                    label="Students"
                    :items="studentList"
                    multiple
                    deletable-chips
                    v-model="selectedStudents"
                    chips
                    item-text="displayname"
                    :hide-details="true"
                    item-value="id"
                    clearable
                  >
                  </v-autocomplete>
                </div>
              </v-col>

              <v-col cols="12" md="6" v-if="this.classSection === 'studentWise'"> </v-col>

              <v-col cols="12" md="6">
                <v-text-field pattern="^[A-Za-z0-9 _]*[A-Za-z0-9 _]$" hint="Enter only characters or numbers (NO special characters allowed)" v-model="scheduleMeeting.topic" label="Class Title"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete key="id" label="Select duration" :items="durationList" v-model="scheduleMeeting.durationID" required item-text="duration" item-value="id" :hide-details="true">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false" :return-value.sync="dates" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox v-model="dates" multiple chips small-chips aria-required="true" label="Select Class Dates" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-combobox>
                  </template>
                  <v-date-picker v-model="dates" multiple :min="minStartDate" :max="maxDate" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateMenu = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.dateMenu.save(dates)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="time" aria-required="true" label="Pick Class Time" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="menu2" v-model="time" full-width format="24hr" @click:minute="$refs.menu.save(time)"></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="8">
                <v-textarea name="input-7-1" clearable clear-icon="mdi-close-circle" label="Class Description" v-model="scheduleMeeting.description"></v-textarea>
              </v-col>
            </v-row>
            <v-card-actions class=" d-flex justify-end">
              <v-btn bottom right elevation="1" color="primary" type="submit">
                <v-icon left> mdi-content-save </v-icon>
                Save
              </v-btn>
            </v-card-actions>
          </form>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
import _ from 'lodash'
import stores from '@/stores'
import moment from 'moment'

export default {
  name: 'OnlineClassList',
  components: {
    VCardComponent,
    MaterialCard
  },
  data () {
    const today = new Date()
    return {
      valid: true,
      inProgress: false,
      minutesGranularity: 5,
      academicYears: [],
      franchiseeList: [],
      time: null,
      dateMenu: false,
      menu2: false,
      modal2: false,
      selectedAcademicYear: '',
      selectedSections: [],
      franchiseeID: '',
      menu: false,
      selectedFranchisees: [],
      selectedClasses: [],
      selectedStaff: [],
      user: stores.user.me,
      searchInput: null,
      staffList: [],
      classes: [],
      franchisees: [],
      allClassData: [],
      dates: [],
      sections: [],
      classSection: 'sectionWise',
      isLoading: false,
      durationList: [],
      studentList: [],
      selectedStudents: [],
      loadingComponent: null,
      academicYearID: null,
      scheduleMeeting: {
        topic: '',
        description: '',
        durationID: ''
      },
      timepicker: {
        incrementMinutes: 15
      },
      selectAllStudents: false,
      minStartDate: new Date().toISOString().slice(0, 10),
      maxDate: new Date(today.getFullYear(), today.getMonth() + 1, today.getDate()).toISOString().slice(0, 10),
      accessToAllClassFlag: false,
      selectAllClassSectionFlag: false
    }
  },
  async created () {
    try {
      await this.getYear()
      await this.getFranchiseeList()
      await this.getDurationList()
      await this.getStaffList()
    } catch (error) {
      console.log(error)
    }
  },
  computed: {},
  mounted: async function () {
    if (this.franchisee) {
      this.franchiseeID = this.franchisee.id
      await this.onFranchiseeChange()
    }
  },
  watch: {
    selectedSections: function (newVal) {
      const element = document.getElementsByClassName('custom__autocomplete')
      if (newVal.length > 25) {
        element[0].style.height = '300px'
        element[0].style.overflow = 'hidden'
        element[0].style.overflowY = 'auto'
      } else {
        element[0].style.height = ''
        element[0].style.overflow = ''
        element[0].style.overflowY = ''
      }
      if (this.classes.length > 0) {
        if (newVal.length === this.classes.length) {
          this.selectAllClassSectionFlag = true
        } else {
          this.selectAllClassSectionFlag = false
        }
      }
    },
    selectedStudents () {
      this.selectAllStudents = this.studentList.length > 0 && this.studentList.length === this.selectedStudents.length
    },
    selectedStaff () {
      if (!this.user.superAdmin) {
        if (this.selectedStaff.length < 1) {
          this.loginUser()
        } else {
          let r = this.selectedStaff.some(a => a.userID === this.user.id)
          if (!r) {
            // this.errMsg('Logged in user cannot be removed!')
            this.loginUser()
          }
        }
      } else {
        // Added Check If selectedStaff is blank.
        if (this.selectedStaff.length < 1) {
          this.classes = []
        }
      }
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }

  },
  methods: {
    radioChange () {
      this.studentList = []
      this.selectedStudents = []
    },
    getStudents: async function () {
      this.selectAllStudents = false
      if (this.classSection !== 'studentWise') {
        return false
      }
      if (!this.selectedSections || this.selectedSections.length === 0) {
        this.errMsg('Kindly select Class-Section value!')
        return false
      }
      this.studentList = []

      let finalSet = _.map(this.selectedSections, a => {
        return {
          'classID': a.studentSection.classID,
          'sectionID': a.studentSection.id,
          'franchiseeID': a.franchisee.id
        }
      })
      let final = {
        'academicYearID': this.selectedSections[0].franchiseeAcademicYear.id,
        'isActive': true,
        'franchiseeSectionClassMap': finalSet
      }
      try {
        this.isLoading = true
        let res = await http.post(`${constants.API_URL}/api/student/class-section-wise`, final)
        this.studentList = res.data
        this.studentList = _.map(this.studentList, a => {
          a.displayname = `${a.studentEnrollment.studentName} | ${a.franchisee.companyName} | ${a.studentClass.name} | ${a.studentSection.name}`
          return a
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        await this.getStaffList()
      } else {

      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/franchisee`)
        this.franchiseeList = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getDurationList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/online-meeting/get-durations`)
        this.durationList = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=false`)
        this.academicYears = response.data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.selectedAcademicYear = academicYear.id
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    loginUser: async function () {
      this.staffList.map(a => {
        if (a.userID === this.user.id) {
          this.selectedStaff.push(a)
        }
      })
      await this.getClassList()
    },
    filterClasses () {
      if (this.selectedFranchisees.length > 1) {
        this.classSection = 'studentWise'
      }
      this.selectedSections = []
      this.studentList = []
      let frIDs = _.map(this.selectedFranchisees, a => a.id)
      this.classes = _.filter(this.allClassData, a => frIDs.includes(a.franchisee.id))
    },
    getClassList: async function (i) {
      console.log(1)
      this.selectedSections = []
      if (!this.selectedStaff || this.selectedStaff.length === 0) {
        // this.errMsg('Kindly select Staff!')
        return false
      }
      let accessToAllClass = []
      this.accessToAllClassFlag = false
      this.selectedStaff.forEach(item => {
        if (typeof item.isAccessToAllClasses !== 'undefined') {
          accessToAllClass.push(item.isAccessToAllClasses)
        }
      })
      if (accessToAllClass.length > 0 && accessToAllClass.indexOf(false) === -1) {
        this.accessToAllClassFlag = true
      }
      // console.log(this.accessToAllClassFlag)
      if (this.accessToAllClassFlag) {
        this.classes = []
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/staff/teacher-class-map?isActive=true&&academicYearID=${this.selectedAcademicYear}&&isAccessToAllClass=${this.accessToAllClassFlag}`)
        if (res.status === 200) {
          this.franchisees = []
          this.selectedFranchisees = []
          let studentClassData = res.data
          studentClassData.forEach(studentClass => {
            studentClass.studentSections.forEach(sections => {
              let exists = this.classes.some(item => (item.valuez === `${studentClass.name} - ${sections.name}`) && (item.valueWithFr === `All - ${studentClass.name} - ${sections.name}`))
              if (!exists) {
                this.classes.push({
                  studentSection: {
                    classID: studentClass.id,
                    id: sections.id,
                    name: sections.name,
                    studentClass
                  },
                  valuez: `${studentClass.name} - ${sections.name}`,
                  valueWithFr: `All - ${studentClass.name} - ${sections.name}`
                })
              }
            })
          })
        }
      } else {
        this.franchisees = []
        this.selectedFranchisees = []
        this.accessToAllClassFlag = false
        for (let a of this.selectedStaff) {
          try {
            this.isLoading = true
            let res = await http.get(`${constants.API_URL}/api/staff/teacher-class-map?userID=${a.userID}&&isActive=true&&academicYearID=${this.selectedAcademicYear}&&isAccessToAllClass=${this.accessToAllClassFlag}`)
            let data = res.data
            for (let r of res.data) {
              this.franchisees.push(r.franchisee)
            }
            data = _.map(data, a => {
              a.valuez = `${a.studentSection.studentClass.name} - ${a.studentSection.name}`
              a.valueWithFr = `${a.franchisee.companyName} - ${a.studentSection.studentClass.name} - ${a.studentSection.name}`
              return a
            })

            if (data) {
              this.sections = []
              for (let classData of data) {
                if (classData.studentSection) {
                  this.sections.push(...[classData.studentSection])
                }
              }
              for (let r of data) {
                this.allClassData.push(r)
              }
              this.filterClasses()
            }
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            return this.errMsg(errorMessage)
          } finally {
            this.isLoading = false
          }
        }
      }
    },
    scheduleOnlineClass: async function () {
      try {
        if (!this.accessToAllClassFlag && (!this.selectedFranchisees || this.selectedFranchisees.length === 0)) {
          this.errMsg('Kindly select Franchisee!')
          return false
        }
        if (!this.selectedSections || this.selectedSections.length === 0) {
          this.errMsg('Kindly select Class-Section value!')
          return false
        }
        if (this.classSection === 'studentWise') {
          if (!this.selectedStudents || this.selectedStudents.length === 0) {
            this.errMsg('Kindly select students!')
            return false
          }
        }

        if (_.isEmpty(this.scheduleMeeting.topic)) {
          return this.errMsg('Class Title can not be empty!')
        }

        if (this.dates.length < 1) {
          this.errMsg('Kindly select Meeting Date!')
          return false
        }
        if (!this.time) {
          this.errMsg('Kindly select Meeting Time!')
          return false
        }
        const meetingDateTimes = []
        for (let date of this.dates) {
          const meetingDate = moment(date).format('YYYY/MM/DD')
          const meetingDateTime = moment(meetingDate + ' ' + this.time).format('YYYY/MM/DD HH:mm:ss')
          const now = moment().format('YYYY/MM/DD HH:mm:ss')
          if (moment(now).isAfter(moment(meetingDateTime))) {
            return this.errMsg(`Cannot set class for past dateTime ${date} ${this.time}`)
          }
          meetingDateTimes.push(meetingDateTime)
        }
        if (!this.scheduleMeeting.durationID) {
          return this.errMsg('Please select class duration!')
        }
        this.scheduleMeeting.franchiseeID = _.map(this.selectedFranchisees, a => a.id)

        this.scheduleMeeting.academicYearID = this.selectedAcademicYear
        this.scheduleMeeting.meetingDateTimes = meetingDateTimes
        this.scheduleMeeting.users = _.map(this.selectedStaff, a => {
          return a.userID
        })
        this.scheduleMeeting.sectionClassMap = _.map(this.selectedSections, a => {
          return {
            'id': a.studentSection.id,
            'name': a.studentSection.name,
            'classID': a.studentSection.classID,
            'value': `${a.studentSection.studentClass.name} - ${a.studentSection.name}`
          }
        })

        if (this.classSection === 'studentWise') {
          this.scheduleMeeting.userStudentID = this.selectedStudents
        }
        this.scheduleMeeting.type = this.classSection === 'studentWise' ? 'STUDENT_WISE' : 'ALL'

        this.isLoading = true
        await http.post(`${constants.API_URL}/api/online-meeting/create`, this.scheduleMeeting)
        this.isLoading = false
        this.$buefy.dialog.alert({
          message: 'Class scheduled successfully!',
          type: 'is-success'
        })
        this.$router.push({ name: 'onlineClass' })
      } catch (e) {
        this.isLoading = false
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    selectSections: async function () {
      const selectedSectionsObjectarray = []
      try {
        if (this.selectedClasses.length) {
          for (let id of this.selectedClasses) {
            const Classes = this.classes.find(obj => obj.id === id)
            if (Classes) {
              if (Classes.studentSections) {
                selectedSectionsObjectarray.push(...Classes.studentSections)
              }
            }
          }

          this.selectedSections.push(...selectedSectionsObjectarray.map(obj => obj.id))
          this.selectedSections = _.uniq(this.selectedSections)
        } else {
          this.selectedClasses = []
          this.selectedSections = []
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getStaffList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/staff/approved?isTeachingStaff=true`)
        this.staffList = data
        if (this.staffList.length) {
          for (let userData of this.staffList) {
            userData.userName = `${userData.user.firstName} ${userData.user.lastName}`
            userData.userID = userData.user.id
            userData.isAccessToAllClasses = userData.user.isAccessToAllClasses
          }
        } else {
          this.staffList = []
          this.selectedClasses = []
          this.selectedSections = []
          this.classes = []
          this.sections = []
        }
        if (!this.user.superAdmin) {
          this.loginUser()
        }

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    selectAllClassSection: function () {
      this.selectedStudents = []
      this.studentList = []
      this.selectedSections = []
      if (this.selectAllClassSectionFlag) {
        this.classes.forEach(item => {
          let exists = this.selectedSections.some(selectedClass => (selectedClass.valuez === item.valuez) && (selectedClass.valueWithFr === item.valueWithFr))
          if (!exists) {
            this.selectedSections.push(item)
          }
        })
        return true
      } else {
        this.selectedSections = []
      }
    },
    resetAll: async function () {
      this.selectAllStudents = false
      this.time = null
      this.dateMenu = false
      this.menu2 = false
      this.modal2 = false
      this.menu = false
      this.dates = []
      this.isLoading = false
      this.loadingComponent = null
      this.scheduleMeeting = {
        topic: '',
        description: '',
        durationID: ''
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.inputBox {
  width: 80% !important;
  border: none;
  border: 1px solid black;
  border-radius: 1%;
  box-shadow: ghostwhite;
}
.customer_details,
.franchisee_details {
  th {
    width: 10rem;
  }

  .table td,
  .table th {
    border: 0;
    padding: 0.3em 0.75em;
  }
}
.hr_yellow {
  background-color: #191d38;
  height: 0.1rem;
}
// div.custom__autocomplete{
//   height:300px!important;
//   overflow: hidden;
//   overflow-y:auto;
// }
</style>
